import { IReqResetPassword } from 'src/@types/reset-password';
import { baseKemedisApi } from './base-kemedis.api';

const prefix = '/api/account/idash/reset-password';

const resetPasswordApi = baseKemedisApi.enhanceEndpoints({
  addTagTypes: ['ResetPassword'],
});

const _apiWithTaggedEndpoint = resetPasswordApi.injectEndpoints({
  endpoints: (build) => ({
    resetPassword: build.mutation<any, IReqResetPassword>({
      query: (data) => ({
        url: `${prefix}`,
        method: 'POST',
        data,
      }),
      invalidatesTags: ['ResetPassword'],
    }),
  }),
});

export const { useResetPasswordMutation } = _apiWithTaggedEndpoint;
